import React from "react";
import Lback from "../../../assets/Images/leftarrow.png";

const ReportDetailNavigation = (props) => {
  const {
    isOpenReportsDetail,
    reconciliationReport,
    setIsOpenReportsDetail,
    setSelectedReconciliation,
  } = props;

  return (
    <>
      {isOpenReportsDetail ? (
        <div className="reconciliation-sidebar-section-reportdetails">
          <div className="reconsidebar-section-reportdetails">
            <div>
              <img
                src={Lback}
                alt="Back arrow"
                onClick={() => {
                  setIsOpenReportsDetail(false);
                  setSelectedReconciliation(null);
                }}
                className="reconsidebar-section-reportdetails-image"
              />
            </div>
            <div className="reconsidebar-section-reportdetails-text">
              View Report Details
            </div>
          </div>
        </div>
      ) : (
        <div className="reconciliation-sidebar-section-reportdetails-button">
          <div className="reconsidebar-section-reportdetails-button">
            <div
              onClick={() => {
                setIsOpenReportsDetail(true);
                reconciliationReport?.metadata?.page_no &&
                  reconciliationReport?.metadata?.quads &&
                  setSelectedReconciliation(
                    reconciliationReport?.metadata || null
                  );
              }}
              className="reconsidebar-section-reportdetails-buttontext"
            >
              View Report Details
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportDetailNavigation;
